import { useEffect, useState } from "react";
import { adminApi } from "./api";

function BannerBar() {
  const [banners, setBanners] = useState([]);
  useEffect(() => {
    adminApi.integrationStatus().then((r) => setBanners(r.data?.banners || []));
  }, []);
  if (!banners.length) return null;
  return (
    <div data-testid="integrations-banners" style={{ marginBottom: 24 }}>
      {banners.map((b) => (
        <div key={b.id} data-testid={`banner-${b.id}`} style={{ padding: "12px 16px", border: "1px solid #E6A855", background: "rgba(230,168,85,0.08)", color: "#E6A855", fontFamily: "var(--gp-font-display)", fontSize: 13, letterSpacing: "0.02em" }}>
          {b.text}
        </div>
      ))}
    </div>
  );
}

export default function IntegrationStatus() {
  return (
    <div className="ga-page" data-testid="integrations-page">
      <div className="ga-eyebrow">Integrations</div>
      <h1 className="ga-title">Delivery &amp; connections</h1>

      <BannerBar />

      {/* EMAIL DELIVERY — disabled by owner decision */}
      <h2 className="ga-group__title" style={{ marginTop: 24 }}>Email Delivery</h2>
      <div className="ga-info-card" data-testid="email-panel">
        <div className="ga-info-card__row" style={{ display: "block" }}>
          <div style={{ fontFamily: "var(--gp-font-display)", fontWeight: 600, marginBottom: 6 }}>Disabled by owner decision</div>
          <p className="ga-mute" style={{ margin: 0, lineHeight: 1.6 }}>
            Email notifications are disabled. Enquiries are stored in this admin and must be checked here regularly.
            To enable outbound notifications in the future, contact your Emergent builder.
          </p>
        </div>
      </div>

      {/* CUSTOM DOMAIN */}
      <h2 className="ga-group__title" style={{ marginTop: 40 }}>Custom Domain</h2>
      <div className="ga-info-card" data-testid="domain-panel">
        <div className="ga-info-card__row" style={{ display: "block" }}>
          <p className="ga-mute" style={{ margin: 0, lineHeight: 1.6 }}>
            Custom domain records are managed by the deployment platform. Contact your Emergent project support to
            change the primary hostname or add subdomains.
          </p>
        </div>
      </div>
    </div>
  );
}
